import React from 'react';
import {
  Form,
  Label,
  FormGroup,
} from 'reactstrap';
import PropTypes from 'prop-types';

import { FormField } from '../../../../../utils/FormFields';

function QuestionsTab({
  account, changedAccount, showChanges,
}) {
  const editQuestions = [];
  changedAccount.Questions.map((q) => {
    if (q.NewAnswerId > 0) editQuestions.push(q);
    return {};
  });
  const compareQuestions = [];
  editQuestions.map((q) => {
    compareQuestions.push({
      ...q,
      NewAnswerId: 0,
    });
    return {};
  });
  return (
    <React.Fragment>
      <Label style={{ fontWeight: 500, fontSize: '20px', display: 'block' }}>
        {showChanges ? 'New changes' : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <React.Fragment>
            {editQuestions.map((q) => (
              <FormToShow question={q} />
            ))}
          </React.Fragment>
        )
        : (
          <React.Fragment>
            {compareQuestions.map((q) => (
              <FormToShow question={q} />
            ))}
          </React.Fragment>
        )}
    </React.Fragment>
  );
}

QuestionsTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default QuestionsTab;

const FormToShow = ({ question }) => (
  <Form>
    <FormGroup tag="fieldset">
      <legend>{question.QuestionDescription}</legend>
      {question.Answer.map((a) => (
        <FormField
          key={a.AnswerId}
          label={a.AnswerDescription}
          disabled={!(a.AnswerIsResponse
            ? question.NewAnswerId === 0 : question.NewAnswerId === a.AnswerId)}
          type="radio"
          value={a.AnswerIsResponse
            ? question.NewAnswerId === 0 : question.NewAnswerId === a.AnswerId}
          changedColor={a.AnswerId === question.NewAnswerId}
        />
      ))}
    </FormGroup>
  </Form>
);

FormToShow.propTypes = {
  question: PropTypes.object.isRequired,
};
